import { UISearchStatusMappingEnum } from './../../models/ui-search-status-mapping-enum';
import { PredefinedSearchService } from './../../service/predefined-search.service';
import { TranslateService } from '@ngx-translate/core';

import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  OnChanges,
  HostBinding,
} from '@angular/core';

@Component({
  selector: 'pioneer-status-chart',
  templateUrl: './status-chart.component.html',
  styleUrls: ['./status-chart.component.css'],
})
export class StatusChartComponent implements OnInit, OnChanges {
  private readonly labelBySearchStatusMapping: { [x: string]: string } = {
    [UISearchStatusMappingEnum.CANCELLED.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.CANCELLED',
    [UISearchStatusMappingEnum.INVOICED.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.INVOICED',
    [UISearchStatusMappingEnum.PAID_DIRECT.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAID_DIRECT',
    [UISearchStatusMappingEnum.PAY_SENT.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAY_SENT',
    [UISearchStatusMappingEnum.PENDING.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PENDING',
    [UISearchStatusMappingEnum.READY_TO_INITIATE.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.READY_TO_INITIATE',
    [UISearchStatusMappingEnum.REQUEST_REJECTED.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.REQUEST_REJECTED',
    [UISearchStatusMappingEnum.REQUESTED.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.REQUESTED',
    [UISearchStatusMappingEnum.RESENT_REQUEST.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.RESENT_REQUEST',
    [UISearchStatusMappingEnum.FUNDED.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.FUNDED',
    [UISearchStatusMappingEnum.PAY_CLEARED.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAY_CLEARED',
    [UISearchStatusMappingEnum.CHECK_STOPPED.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.CHECK_STOPPED',
    [UISearchStatusMappingEnum.PAY_REISSUED.toString()]:
      'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAY_REISSUED',
  };

  @Input() chartData = [];
  @Input() width = 300;
  @Input() height = 400;

  colors = [
    '#00BD12',
    '#007AD1',
    '#44BAEF',
    '#E70000',
    '#96D886',
    '#B1E7FF',
    '#012974',
    '#1D8800',
    '#B3B3B3',
    '#FFCF2C',
    '#B200FF',
    '#FF6A00',
    '#FF00DC',
    '#606060',
  ];

  totalEvents = 0;
  radius = 95;

  constructor(
    private translateService: TranslateService,
    private predefinedSearchService: PredefinedSearchService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    let x = 0;

    this.chartData.sort((a, b) =>
      a.list_order < b.list_order ? -1 : a.list_order > b.list_order ? 1 : 0
    );

    this.chartData.forEach((element) => {
      element.color = element.color;
      element.selected = false;
      element.label = this.labelForPaymentStatusValue(element.code);
      x++;
      if (x === 14) {
        x = 0;
      }
      this.totalEvents += element.value;
    });
    let accumulatedDegrees = 0;
    let childNumber = 1;
    let chartCssString = '';
    this.chartData.forEach((element) => {
      element.percent = (element.value * 100) / this.totalEvents;
      let degrees = element.percent * 3.6;
      if (this.chartData.length > 1 && element.percent > 1) {
        element.rotateDegree = 'calc(-90deg + ' + accumulatedDegrees + 'deg)';
      } else {
        element.rotateDegree = 'calc(-90deg + ' + accumulatedDegrees + 'deg)';
      }
      accumulatedDegrees += degrees;
      chartCssString += this.generateItemCssString(
        element,
        childNumber,
        this.chartData.length
      );
      childNumber++;
    });
    this.appendCss(chartCssString);
  }

  labelForPaymentStatusValue(filterValue: string): string {
    const label = this.labelBySearchStatusMapping[filterValue] || filterValue;
    return this.translateService.instant(label);
  }

  generateItemCssString(element, childNumber: number, total: number) {
    let pi = 3.14159265359;
    let percent = element.percent;
    // if (total > 1 && element.percent > 1) {
    //   percent = element.percent - 0.4;
    // }

    let val1 = ((this.radius * percent) / 100) * 2 * pi;
    let val2 = this.radius * (1 - percent / 100) * 2 * pi;

    const cssString =
      `
      @keyframes percent` +
      childNumber +
      ` {
        to {
          stroke-dasharray: ` +
      val1 +
      ` ` +
      val2 +
      ` ;
        }
      }
      .donut:nth-child(` +
      childNumber +
      `) {
        transform: rotateZ(` +
      element.rotateDegree +
      `);
        animation: percent` +
      childNumber +
      ` 0s ease-in-out forwards;
      }`;

    return cssString;
  }

  appendCss(cssString: string) {
    let style = document.createElement('STYLE');
    style.innerText = cssString;
    document.body.appendChild(style);
  }

  trMouseOver(item) {
    item.selected = true;
  }

  trMouseOut(item) {
    item.selected = false;
  }

  launchEventListPage(chartItem: any): void {
    if (chartItem.code === 'readyToInitiate') {
     return;
    }
    this.predefinedSearchService.paymentStatusSearch(chartItem.code);
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/status-chart/status-chart.component.ts